import { Capacitor } from "@capacitor/core";

export type RestorePurchaseCopy = {
  restoreNothingFound: string;
  restoreNothingFoundApple: string;
  restoreNothingFoundGoogle: string;
};

/**
 * Platform-appropriate copy when Restore Purchases finds no active premium
 * entitlement. Android must never mention Apple ID; iOS keeps Apple-specific
 * wording for App Review accuracy.
 */
export function getRestoreNothingFoundMessage(
  purchase: RestorePurchaseCopy,
  platform: string = Capacitor.getPlatform(),
): string {
  if (platform === "ios") return purchase.restoreNothingFoundApple;
  if (platform === "android") return purchase.restoreNothingFoundGoogle;
  return purchase.restoreNothingFound;
}
